import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importEntries } from '../services/api/timeEntry';
import { invalidateMany } from './queryUtils';
import { INVALIDATE_KEYS } from './useTimesheetMutations';

export function useImportEntries() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, file, dryRun }: { projectId: number; file: File; dryRun?: boolean }) =>
      importEntries(projectId, file, dryRun),
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        // F5-006: a successful Excel import affects the calendar grid,
        // cockpit cards, pending-approval queues, current timesheet, and
        // admin lists — not just the `allTimesheets` query. Reuse the same
        // INVALIDATE_KEYS shared by the approve/reject/submit mutations so
        // every dependent view refetches.
        invalidateMany(queryClient, INVALIDATE_KEYS);
      }
    },
  });
}
